import React from "react";
import { FormattedMessage, type MessageDescriptor } from "react-intl";

export default function ProbablyFormattedMessage({ id }: { id?: MessageDescriptor["id"] }) {
  return <FormattedMessage id={id || "None"} />;
}
